/**
 * Shared Day.js configuration for all themes
 * Configures Day.js with necessary plugins and locales.
 *
 * @module dayjs-config
 * 
 * @example
 * import dayjs from '@shared/plugins/dayjs-config';
 * // Use dayjs directly - all plugins are already configured
 * dayjs().format('YYYY-MM-DD');
 */

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import duration from 'dayjs/plugin/duration';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import 'dayjs/locale/de';
import 'dayjs/locale/es';
import 'dayjs/locale/it';
import 'dayjs/locale/pt';
import 'dayjs/locale/ru';
import 'dayjs/locale/ar';
import 'dayjs/locale/ko';

dayjs.extend(utc);
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);
dayjs.extend(duration);
dayjs.extend(customParseFormat);

dayjs.locale('en');

export default dayjs;
